<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()"
      @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :md="5" :sm="12">
          <el-form-item label="日期:">
            <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="handleDateChange" clearable
              style="width: 270px" />
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="年级:">
            <el-select v-model="table.where.gradeId" placeholder="请选择年级" clearable @change="handleChangeGrade">
              <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="4" :sm="12">
          <el-form-item label="项目:">
            <el-select v-model="table.where.accessProjectId" placeholder="请选择项目" @change="$forceUpdate()" clearable>
              <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="6" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
              class="ele-btn-icon">查询</el-button>
            <el-button @click="(table.where = {}) && date == null && $refs.table.reload()">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 操作按钮 -->
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">录入</el-button>
      <el-button @click="exportInfo" type="primary" icon="el-icon-download" class="ele-btn-icon"
        size="small">导出</el-button>
      <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon"
        size="small">批量删除</el-button>
    </div>
    <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class"
      highlight-current-row>
      <template>
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column type="index" width="45" align="center" />
        <el-table-column prop="studentName" label="姓名" show-overflow-tooltip align="center" />
        <el-table-column prop="studentNumber" label="学号" show-overflow-tooltip align="center" />
        <el-table-column prop="branchName" label="学部" show-overflow-tooltip align="center" />
        <el-table-column prop="gradeName" label="年级" show-overflow-tooltip align="center" />
        <el-table-column prop="className" label="班级" show-overflow-tooltip align="center" />
        <el-table-column prop="accessProjectName" label="项目" show-overflow-tooltip align="center" />
        <el-table-column prop="accessItemName" label="细则" show-overflow-tooltip align="center" />
        <el-table-column prop="itemType" label="属性" show-overflow-tooltip align="center" width="60">
          <template slot-scope="{ row }">
            {{ row.itemType == 1 ? '加分' : row.itemType == 2 ? '减分' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="studentScore" label="分值" show-overflow-tooltip align="center" width="50">
          <template slot-scope="{ row }">
            <span
              :style="{ color: row.studentScore > 0 ? '#409EFF' : row.studentScore < 0 ? '#F56C6C' : '', fontWeight: 'bold' }">
              {{ row.studentScore }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="createDay" label="录入日期" show-overflow-tooltip align="center" />
        <el-table-column prop="createUser" label="录入人" show-overflow-tooltip align="center" />
        <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center" />
        <el-table-column label="操作" align="center" width="150">
          <template #default="{ row }">
            <el-link @click="editInfo(row)" icon="el-icon-edit" type="primary" :underline="false">编辑</el-link>
            <el-popconfirm title="确定要删除此数据？" @onConfirm="remove(row)" class="ele-action">
              <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
            </el-popconfirm>
          </template>
        </el-table-column>
      </template>
    </ele-data-table>
    <el-dialog :title="editForm.id ? '编辑' : '录入'" :visible.sync="showEdit" width="60%" @closed="resetForm"
      :destroy-on-close="true" custom-class="ele-dialog-form" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px">
        <div style="display: flex;align-items: center">
          <el-input v-model="studentName" placeholder="请输入学生姓名" clearable style="width: 180px;margin-right: 20px" />
          <el-button type="primary" @click="searchStudent">搜索</el-button>
        </div>
        <el-row :gutter="15" style="margin-top: 20px">
          <el-col :sm="6">
            <el-form-item label="年级:" prop="gradeId">
              <el-select v-model="editForm.gradeId" placeholder="请选择年级" clearable @change="handleDialogGradeChange">
                <el-option v-for="item in dialogData.gradeList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="班级:" prop="classId">
              <el-select v-model="editForm.classId" placeholder="请选择班级" clearable @change="handleDialogClassChange">
                <el-option v-for="item in dialogData.classList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="姓名:" prop="studentName">
              <el-input v-model="editForm.studentName" readonly placeholder="请搜索学生选择" />
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="学号:" prop="studentNumber">
              <el-input v-model="editForm.studentNumber" placeholder="请输入学生学号" />
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="项目:" prop="accessProjectId">
              <el-select v-model="editForm.accessProjectId" @change="handleChangeProject" placeholder="请选择项目"
                class="ele-block" clearable>
                <el-option v-for="item in dialogData.projectList" :key="item.id" :label="item.projectName"
                  :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="细则:" prop="accessItemId">
              <el-select v-model="editForm.accessItemId" placeholder="请选择细则" class="ele-block" @change="$forceUpdate()"
                clearable>
                <el-option v-for="item in dialogData.itemList" :key="item.id" :label="item.itemName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="录入日期:" prop="createDay">
              <el-date-picker v-model="editForm.createDay" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                style="width: 183px" clearable />
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="录入人:" prop="createUser">
              <el-input v-model="editForm.createUser" />
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item label="备注:">
              <el-input v-model="editForm.remark" />
            </el-form-item>
          </el-col>
          <el-col :sm="24">
            <el-form-item label="上传照片:">
              <el-upload class="avatar-uploader" list-type="picture-card"
                :action="$http.defaults.baseURL + '/file/getFilePath'" :headers="$http.defaults.headers.common"
                :data="{ path: 'yzExamine/' }" name="multipartFile" :limit="3" :file-list="fileList"
                :on-preview="handlePictureCardPreview" :on-remove="removeImg" :on-success="uploadSuccess"
                :before-upload="beforeAvatarUpload" accept="image/png,image/jpg,image/jpeg">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false">取 消</el-button>
        <el-button type="primary" @click="saveRecord">确 定</el-button>
      </span>
    </el-dialog>
    <!--学生列表-->
    <el-dialog title="学生信息" :visible.sync="showStudent" width="50%">
      <ele-data-table ref="studentTable" :config="studentTable" :data="studentList" highlight-current-row>
        <template>
          <el-table-column prop="studentName" label="姓名" show-overflow-tooltip align="center" />
          <el-table-column prop="studentNumber" label="学号" show-overflow-tooltip align="center" />
          <el-table-column prop="branchName" label="学部" show-overflow-tooltip align="center" />
          <el-table-column prop="gradeName" label="年级" show-overflow-tooltip align="center" />
          <el-table-column prop="className" label="班级" show-overflow-tooltip align="center" />
          <el-table-column label="操作" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="chooseStudent(row)" icon="el-icon-mouse" type="primary" :underline="false">选择</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showStudent = false">取 消</el-button>
        <el-button type="primary" @click="showStudent = false">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 照片预览 -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  delGradeAccessRecord,
  exportGradeAccessRecord,
  getGradeAccessItemList,
  gradeAccessProjectList,
  saveGradeAccessRecord,
  gradeSearchStudent,
  gradeSelectionList,
  getGradeList
} from '@/config/yizhongDong/examine';

export default {
  name: 'GradePersonal',
  data () {
    return {
      table: {
        // 表格配置
        url: '/gradeAccess/teacherAccessRecordPage',
        method: 'GET',
        where: {
          type: 1
        },
        parseData (res) {
          if (res.resCode == 200) res.code = 0;
          res.count = res.data.total;
          res.data = res.data.records;
          return res;
        },
      },
      choose: [],
      editForm: {
        gradeId: undefined,
        classId: undefined,
        accessProjectId: undefined,
        accessItemId: undefined,
        studentId: undefined,
        studentName: '',
        createDay: undefined,
        createUser: '',
        studentNumber: '',
        remark: '',
        photos: [],
        type: 1
      },
      editRules: {
        gradeId: [{ required: true, message: '请选择年级', trigger: 'change' }],
        classId: [{ required: true, message: '请选择班级', trigger: 'change' }],
        createDay: [{ required: true, message: '请选择录入日期', trigger: 'change' }],
        accessProjectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        accessItemId: [{ required: true, message: '请选择项目细则', trigger: 'change' }],
        studentNumber: [{ required: true, message: '请输入学号', trigger: 'blur' }],
        createUser: [{ required: true, message: '请输入录入人', trigger: 'blur' }],
        studentName: [{ required: true, message: '请输入学生姓名', trigger: 'blur' }],
      },
      gradeList: [],
      projectList: [],
      showEdit: false,
      studentName: null,
      dialogData: {
        gradeList: [],
        classList: [],
        projectList: [],
        itemList: [],
      },
      studentList: [],
      showStudent: false,
      studentTable: {
        page: false,
      },
      date: null,
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: null,
    };
  },
  created () {
    // 获取年级
    this.getGrade(true);
  },
  methods: {
    // 获取年级
    getGrade (first) {
      getGradeList().then((res) => {
        if (res.data.resCode == 200) {
          this.gradeList = res.data.data || [];
          if (first && this.gradeList.length > 0) {
            this.table.where.gradeId = this.gradeList[0].id;
            this.getProject(this.gradeList[0].id);
          }
        }
      });
    },
    // 获取项目
    getProject (gradeId) {
      gradeAccessProjectList({ gradeId: gradeId }).then((res) => {
        if (res.data.resCode == 200) {
          this.projectList = res.data.data || [];
        }
      });
    },
    // 选择年级时
    handleChangeGrade (gradeId) {
      this.table.where.accessProjectId = undefined;
      this.projectList = [];
      this.getProject(gradeId);
    },
    // 日期选择
    handleDateChange (value) {
      this.table.where.startTime = value[0];
      this.table.where.endTime = value[1];
    },
    // 级联获取项目和细则数据（用于弹窗表单）
    async loadCascadeData (gradeId, projectId = null) {
      try {
        if (gradeId !== undefined && gradeId !== null) {
          const projectRes = await gradeAccessProjectList({ gradeId });
          if (projectRes.data.resCode == 200) {
            this.dialogData.projectList = projectRes.data.data || [];

            if (projectId !== undefined && projectId !== null) {
              const itemRes = await getGradeAccessItemList({ projectId: projectId });
              if (itemRes.data.resCode == 200) {
                this.dialogData.itemList = itemRes.data.data || [];
              }
            } else {
              this.dialogData.itemList = [];
            }
          } else {
            this.dialogData.projectList = [];
            this.dialogData.itemList = [];
          }
        } else {
          this.dialogData.projectList = [];
          this.dialogData.itemList = [];
        }
      } catch (error) {
        console.error('加载级联数据失败:', error);
        this.$message.error('数据加载失败，请重试');
      }
    },
    //选择项目时
    async handleChangeProject (projectId) {
      if (projectId) {
        const itemRes = await getGradeAccessItemList({ projectId });
        if (itemRes.data.resCode == 200) {
          this.dialogData.itemList = itemRes.data.data || [];
        }
      } else {
        this.dialogData.itemList = [];
      }
    },
    // 弹窗中选择年级时
    async handleDialogGradeChange (gradeId) {
      this.editForm.classId = undefined;
      this.editForm.accessProjectId = undefined;
      this.editForm.accessItemId = undefined;
      this.dialogData.classList = [];
      this.dialogData.projectList = [];
      this.dialogData.itemList = [];

      if (gradeId) {
        const classRes = await gradeSelectionList({ type: 4, projectType: 2, id: gradeId });
        if (classRes.data.resCode == 200) {
          this.dialogData.classList = classRes.data.data || [];
        }
        await this.loadCascadeData(gradeId);
      }
    },
    // 弹窗中选择班级时
    async handleDialogClassChange (classId) {
      this.editForm.accessProjectId = undefined;
      this.editForm.accessItemId = undefined;
      this.dialogData.itemList = [];
    },
    //录入弹窗
    async add () {
      this.showEdit = true;
      this.editForm.createUser = JSON.parse(sessionStorage.getItem('user')).teacherName;
      this.dialogData = {
        gradeList: [...this.gradeList],
        classList: [],
        projectList: [],
        itemList: [],
      };
      if (this.gradeList && this.gradeList.length > 0) {
        this.editForm.gradeId = this.gradeList[0].id;
        const classRes = await gradeSelectionList({ type: 4, projectType: 2, id: this.gradeList[0].id });
        if (classRes.data.resCode == 200) {
          this.dialogData.classList = classRes.data.data || [];
        }
        await this.loadCascadeData(this.gradeList[0].id);
      }
    },
    // 编辑弹窗
    async editInfo (row) {
      this.editForm = Object.assign({}, row);
      this.fileList =
        row.photos !== null && row.photos !== ''
          ? row.photos.split(',').map((item) => {
            return { url: item };
          })
          : [];
      this.editForm.photos =
        row.photos !== null && row.photos !== ''
          ? row.photos.split(',').map((item) => {
            return { url: item };
          })
          : [];
      this.showEdit = true;
      this.dialogData.gradeList = [...this.gradeList];

      if (row.gradeId) {
        const classRes = await gradeSelectionList({ type: 4, projectType: 2, id: row.gradeId });
        if (classRes.data.resCode == 200) {
          this.dialogData.classList = classRes.data.data || [];
        }
        await this.loadCascadeData(row.gradeId, row.accessProjectId);
      }
    },
    // 删除
    remove (row) {
      if (!row) {
        // 批量删除
        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.choose.map((d) => d.id);
        this.$confirm('确定要删除选中的数据吗?', '提示', { type: 'warning' })
          .then(() => {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            formData.append('ids', ids);
            delGradeAccessRecord(formData)
              .then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              })
              .catch((e) => {
                loading.close();
                this.$message.error(e.message);
              });
          })
          .catch(() => 0);
      } else {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('ids', [row.id]);
        delGradeAccessRecord(formData)
          .then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            loading.close();
            this.$message.error(e.message);
          });
      }
    },
    // 搜索学生
    searchStudent () {
      if (this.studentName == null || this.studentName == '') return this.$message.error('请输入学生姓名进行搜索！');
      gradeSearchStudent({ studentName: this.studentName }).then((res) => {
        if (res.data.resCode == 200) {
          this.studentList = res.data.data;
          this.showStudent = true;
        }
      });
    },
    // 选择学生
    async chooseStudent (row) {
      this.editForm.gradeId = row.gradeId;
      this.editForm.classId = row.classId;
      this.editForm.studentId = row.id;
      this.editForm.studentName = row.studentName;
      this.editForm.studentNumber = row.studentNumber;
      if (row.gradeId) {
        const classRes = await gradeSelectionList({ type: 4, projectType: 2, id: row.gradeId });
        if (classRes.data.resCode == 200) {
          this.dialogData.classList = classRes.data.data || [];
        }
        await this.loadCascadeData(row.gradeId);
      }
      this.showStudent = false;
    },
    //照片上传限制
    beforeAvatarUpload (file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1) === 'png';
      const extension2 = file.name.substring(file.name.lastIndexOf('.') + 1) === 'jpg';
      if (!extension && !extension2) {
        this.$message.error('只能上传png、jpg格式的图片');
        return false;
      }
    },
    // 上传单个照片成功
    uploadSuccess (res) {
      if (res.resCode == 200) {
        this.editForm.photos.push({
          name: res.data[0].fileName,
          url: res.data[0].fileUrl,
        });
      }
    },
    // 预览照片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 移除照片的钩子
    removeImg (file, fileList) {
      this.editForm.photos.forEach((item, index) => {
        if (file.name == item.name) {
          this.editForm.photos.splice(index, 1);
        }
      });
    },
    // 保存评测记录
    saveRecord () {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({ lock: true });
          this.editForm.photos = this.editForm.photos.map((d) => d.url).join(',');
          let formData = new FormData();
          for (let key in this.editForm) {
            if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
              formData.append(key, this.editForm[key]);
            }
          }
          saveGradeAccessRecord(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.showEdit = false;
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 导出数据
    exportInfo () {
      exportGradeAccessRecord(this.table.where).then((res) => {
        let blob = new Blob([res.data], {
          type: 'application/octet-stream',
        });
        let objectUrl = URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = objectUrl;
        let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
      });
    },
    //重置表单
    resetForm () {
      this.editForm = {
        branchId: undefined,
        gradeId: undefined,
        classId: undefined,
        accessProjectId: undefined,
        accessItemId: undefined,
        studentId: undefined,
        studentName: '',
        createDay: undefined,
        createUser: '',
        studentNumber: '',
        remark: '',
        photos: [],
        type: 1
      };
      this.fileList = [];
      this.$refs['editForm'].resetFields();
    },
  },
};
</script>

<style scoped></style>
